/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Email_SentInputs */



/**
* | output |
* | --- |
* | "An email has been sent to your address if you have an account" |
*
* @param {Account_Email_SentInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const account_email_sent = /** @type {((inputs?: Account_Email_SentInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Email_SentInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("An email has been sent to your address if you have an account")
	return /** @type {LocalizedString} */ ("Un email a été envoyé à votre adresse si vous possédez un compte")
});